import { Country } from "../model/Country";

export class CountrySorters {
    public static sortAlphabetically(country1: Country, country2: Country): number {
        let a: any[] = [country1.ggsCountryCode, country2.ggsCountryCode];

        // Sort ascending
        a.sort();

        if (country1.ggsCountryCode === country2.ggsCountryCode) {
            return 0;
        } else if (a.indexOf(country1.ggsCountryCode) < a.indexOf(country2.ggsCountryCode)) {
            return -1;
        } else {
            return 1;
        }
    }
}
